export default class BrowserNavigation {
    static redirectToPrevious(url = null) {
        window.location.href =url || cookies.get("previous-url");
    }
} 